import React from 'react';
import PropTypes from 'prop-types';
import {InputAdornment, TextField} from '@material-ui/core';
import {ReactComponent as SearchIcon} from '../../assets/icons/searchIcon.svg';
import {ReactComponent as ClearIcon} from '../../assets/icons/clearIcon.svg';

import './InputMUISearch.scss';

const InputMUISearch = ({
  autoComplete,
  autoFocus = false,
  className = '',
  defaultValue,
  disabled = false,
  error,
  fullWidth = false,
  helperText,
  id,
  inputProps = {},
  inputRef,
  label,
  maxRows,
  minRows,
  multiline = false,
  name = '',
  onChange,
  placeholder,
  required = false,
  size = 'medium',
  value,
  variant = 'outlined',
  shrink,
  endAdornment,
  onSearch,
  onClear,
  ...props
}) => {
  const handleClear = () => {
    if (onClear) {
      onClear();
    }
  };

  return (
    <TextField
      autoComplete={autoComplete}
      autoFocus={autoFocus}
      className={`${className} input-mui-search`}
      classes={{root: 'input-mui-search'}}
      defaultValue={defaultValue}
      disabled={disabled}
      error={!!error}
      fullWidth={fullWidth}
      helperText={helperText}
      id={id}
      inputProps={inputProps}
      inputRef={inputRef}
      label={label}
      maxRows={maxRows}
      minRows={minRows}
      multiline={multiline}
      name={name}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
      size={size}
      type='text'
      value={value}
      variant={variant}
      {...props}
      InputProps={{
        classes: {
          root: 'input-mui-search__root',
          focused: 'input-mui-search__root--focused',
          disabled: 'input-mui-search__root--disabled',
          error: 'input-mui-search__root-error',
          multiline: 'input-mui-search__root--multiline',
          input: 'input-mui-search__input'
        },
        endAdornment: (
          <InputAdornment className='input-mui-search__end-adornment' position='end'>
            {value && (
              <button className='clear-button' type='button' onClick={handleClear}>
                <ClearIcon />
              </button>
            )}
            <button className='search-button' type='button' onClick={onSearch}>
              <SearchIcon />
            </button>
            {endAdornment}
          </InputAdornment>
        )
      }}
      FormHelperTextProps={{
        classes: {
          root: `input-mui-search__helper-text${error ? ' input-mui-search__helper-text--error ' : ''}`
        }
      }}
      InputLabelProps={{
        classes: {
          root: 'input-mui-search__label',
          focused: 'input-mui-search__label--focused',
          shrink: 'input-mui-search__label--shrink',
          error: 'input-mui-search__label--error',
          disabled: 'input-mui-search__label--disabled'
        },
        shrink: shrink
      }}
    />
  );
};

InputMUISearch.propTypes = {
  autoComplete: PropTypes.string,
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  defaultValue: PropTypes.any,
  disabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  fullWidth: PropTypes.bool,
  helperText: PropTypes.node,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  inputRef: PropTypes.any,
  label: PropTypes.node,
  maxRows: PropTypes.number,
  minRows: PropTypes.number,
  multiline: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
  onClear: PropTypes.func,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  size: PropTypes.oneOf(['medium', 'small']),
  value: PropTypes.any,
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard']),
  endAdornment: PropTypes.node
};

export default InputMUISearch;
